import React from 'react';
import VideoCard from './VideoCard';

export default function VideoGrid({ videos = [], columns = 2, onOpen }) {
    return (
        <div className={`hb-video-grid hb-video-grid--${columns}`}>
            {videos.map(v => (
                <VideoCard
                    key={v.id}
                    video={v}
                    compact={columns === 3}
                    onClick={onOpen ? () => onOpen(v.id) : undefined}
                />
            ))}
        </div>
    );
}
